module.exports = __webpack_public_path__ + "static/img/address.afbd25f6.png";